import styled, { css } from 'styled-components';
import {
  PADDING,
  REBRAND_COLOR,
  REBRAND_GRADIENT,
  BREAKPOINT
} from '@latitude/core/utils/constants';
import Section from '@latitude/section-rebrand';

export const Wrapper = styled.div`
  background: ${REBRAND_COLOR.STONE};
`;

export const StyledPopCollectionContainer = styled(Section)`
  padding-top: ${PADDING.P32};
  padding-bottom: ${PADDING.P32};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 32px;
  h4 {
    text-align: center;
  }
`;

export const StyledPopContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
   @media (min-width: ${BREAKPOINT.LG}) {
  width: 100%;
}
`;